import styled from 'styled-components'

import { ImageCropperStyled } from '@ui/blocks/ImageCropper/styles/ImageCropperStyled'
import { FlexRowStyled } from '@ui/elements/Flex/styles/FlexRowStyled'

interface IFilePreviewPreviewContainerStyledProps {}

export const FilePreviewPreviewContainerStyled = styled.div<IFilePreviewPreviewContainerStyledProps>`
  position: absolute;

  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  ${ImageCropperStyled} {
    height: 100%;

    > ${FlexRowStyled} {
      bottom: ${(props) => props.theme.typography.pxToRem(16)};
      opacity: 0;
      transition: opacity 0.3s;
    }

    &:hover {
      > ${FlexRowStyled} {
        opacity: 1;
      }
    }
  }
`
